import React, { useEffect, useState } from 'react';
import { Outlet } from '@tanstack/react-router';
import { ChatHeader } from '../../components/Pleri/components/ChatBox/ChatHeader';
import { useChatStore } from '../../components/Pleri/store/chatStore';
import { MiniSidebar } from '../../components/Pleri/components/ChatBox/MiniSidebar';

// Configuration: Minimum screen width (in pixels) for MiniSidebar to be visible
const MINI_SIDEBAR_MIN_WIDTH = 768;

export const ExtensionLayout = () => {
  const [showMiniSidebar, setShowMiniSidebar] = useState(true);

  // Check screen size and update MiniSidebar visibility
  useEffect(() => {
    const checkScreenSize = () => {
      setShowMiniSidebar(window.innerWidth >= MINI_SIDEBAR_MIN_WIDTH);
    };

    // Check on mount
    checkScreenSize();

    // Listen for resize events
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const handleClose = () => {
    window.close();
  };

  const handleTriggerClick = () => {
    // Trigger is already open (we're in mini view), so clicking it closes
    handleClose();
  };

  const { setActiveConversation, activeConversationId, createConversation } =
    useChatStore();

  // Create a conversation when the component mounts if there's no active conversation
  useEffect(() => {
    if (!activeConversationId) {
      const newId = createConversation();
      setActiveConversation({ conversationId: newId });
    }
  }, [activeConversationId, createConversation, setActiveConversation]);

  // Note: We use setMiniMode directly here because when toggling from mini to fullscreen,
  // we don't want to close the focused view. Only use minimizeToMiniMode when minimizing FROM fullscreen.

  return (
    <div
      className="flex h-screen w-full"
      style={{ position: 'relative', zIndex: '9999999999999999999' }}
    >
      {showMiniSidebar && <MiniSidebar onClick={handleTriggerClick} />}
      <div className="flex h-full flex-1 flex-col overflow-hidden border-l border-gray-200 bg-white shadow-2xl ring-1 ring-gray-200/50 dark:border-gray-700 dark:bg-gray-900 dark:ring-gray-700/50">
        <div>
          <ChatHeader
            isFullScreen={!!showMiniSidebar}
            isExtension={true}
            {...(!showMiniSidebar && {
              onFullScreenToggle: async () => {
                // Open a new tab with the side panel content first
                await chrome.tabs.create({
                  url: chrome.runtime.getURL('sidePanel.html'),
                });
                // Close the side panel after the tab is created
                window.close();
              },
            })}
            onClose={() => {
              window.close();
            }}
            className="px-4 py-3"
          />
        </div>
        <div className="relative flex flex-1 flex-row overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
